<template>
  <el-dialog :visible.sync="dialogVisible" width="760px" :show-close="false">
    <img
      class="close-img"
      alt="close-icon.png"
      @click="dialogVisible = false"
      src="@/assets/img/images/icon/close-icon.png"
    />
    <p class="p1">{{ $t("user_assets.web_record.recharge2") }}</p>
    <p class="p2">
      {{ $t("rechargeCoins.coin_type") }}
    </p>
    <el-select
      v-model="currRow.assetType"
      :placeholder="$t('rechargeCoins.coin_type')"
      class="coin-select"
      @change="selectCoinType"
    >
      <el-option
        v-for="coin in coinTypesList"
        :key="coin"
        :label="coin | replaceUSDT"
        :value="coin"
      />
    </el-select>
    <p class="p2">
      {{ $t("user_assets.blockchain_type") }}
    </p>
    <div class="type-box">
      <p
        v-for="item in networksList"
        :class="[{ sel: currNetwork === item }]"
        @click="typeChange(item)"
      >
        {{ item }}
      </p>
    </div>
    <p class="p2" v-if="!notSupportDeposit">
      {{ currRow.assetType | replaceUSDT }}
      {{ $t("user_assets.web_record.rechargeAddress") }}：
    </p>
    <div class="not-support-box" v-if="notSupportDeposit">
      <img
        src="@/assets/img/images/icon/warning-icon.png"
        alt="warning-icon.png"
      />
      {{ notSupportMsg }}
    </div>
    <div class="img-box" v-if="!notSupportDeposit">
      <qriously
        :value="
          currRow.assetType === 'BCH' && addressObj.addressType === 'old'
            ? addressObj.secondAddress
            : addressObj.address
        "
        :size="90"
      />
      <div class="div-box">
        {{
          currRow.assetType === "BCH" && addressObj.addressType === "old"
            ? addressObj.secondAddress
            : addressObj.address
        }}
        <img
          src="@/assets/img/images/icon/copy.png"
          alt="copy.png"
          @click="copyToClipboard()"
        />
      </div>
    </div>
    <div class="tips-box">
      <img
        src="@/assets/img/images/icon/warning-icon.png"
        alt="warning-icon.png"
      />
      {{ $t("user_assets.web_record.rechargeTips") }}
    </div>
	<div class="tips-box">
	  <img
	    src="@/assets/img/images/icon/warning-icon.png"
	    alt="warning-icon.png"
	  />
	 {{ $t("user_assets.web_record.rechargeTips1") }}{{ addressObj.minAmount }}，{{ $t("user_assets.web_record.rechargeTips2") }} {{ addressObj.maxAmount }}，{{ $t("user_assets.web_record.rechargeTips3") }}
	</div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      networksList: [],
      currNetwork: "BNB",
      currRow: {
        assetType: "",
      },
      addressObj: {
        address: "",
        secondAddress: "",
      },
      dialogVisible: false,
      coinTypesList: [],
      notSupportDeposit: true,
      notSupportMsg: "",
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  mounted() {},
  methods: {
    typeChange(val) {
      this.currNetwork = val;
      this.initNetwork(val);
    },
    selectCoinType(coin) {
      this.networksList = [];
      this.currNetwork = "";
      this.addressObj = { address: "", secondAddress: "" };
      this.notSupportDeposit = false;
      this.notSupportMsg = "";
      this.$axios
        .post("/Coin/getSupportedNetworks", {
          coinType: coin,
          network: "",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.networksList = res.data.networks;
            if (this.networksList && this.networksList.length > 0) {
              this.currNetwork = this.networksList[0];
              this.initNetwork(this.networksList[0]);
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    init(row) {
      this.currRow = row;
      this.$axios
        .post("/userAssets/queryAssetList", {})
        .then((res) => {
          if (res.data.code === this.errorCode.ok && res.data.data && res.data.data.userAssetRsps) {
            this.coinTypesList = res.data.data.userAssetRsps.map(item => item.assetType);
            if (this.currRow.assetType && this.coinTypesList.includes(this.currRow.assetType)) {
              this.loadNetworkAndAddress();
            } else if (this.coinTypesList.length > 0) {
              this.currRow.assetType = this.coinTypesList[0];
              this.loadNetworkAndAddress();
            }
          }
        });
      this.dialogVisible = true;
    },
    loadNetworkAndAddress() {
      this.$axios
        .post("/Coin/getSupportedNetworks", {
          coinType: this.currRow.assetType,
          network: "",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.networksList = res.data.networks;
            if (this.networksList && this.networksList.length > 0) {
              this.currNetwork = this.networksList[0];
              this.initNetwork(this.networksList[0]);
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    initNetwork(val) {
      //充值，每次点击展开再拉去充值地址
      this.$axios
        .post("/userAssets/deposit", {
          coinType: this.currRow.assetType,
          network: val,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.notSupportDeposit = false;
            this.notSupportMsg = "";
            res.data.data.addressType = "new";
            this.addressObj = res.data.data;
          } else if (res.data.code === "DEPOSIT000") {
            this.notSupportDeposit = true;
            this.notSupportMsg = res.data.msg;
            this.addressObj = { address: "", secondAddress: "" };
          } else {
            this.notSupportDeposit = false;
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    copyToClipboard() {
      let str = "";
      if (
        this.currRow.assetType === "BCH" &&
        this.addressObj.addressType === "old"
      ) {
        str = this.addressObj.secondAddress;
      } else {
        str = this.addressObj.address;
      }
      navigator.clipboard
        .writeText(str)
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t("tipsVal.copySucess"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: this.$t("tipsVal.copyerror"),
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__body {
    padding-top: 0px;
    position: relative;
  }
}
.close-img {
  top: -10px;
  right: 20px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: absolute;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 24px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-top: 20px;
}
.tips-box {
  gap: 15px;
  display: flex;
  margin-top: 15px;
  align-items: center;
  padding: 10px 14px;
  background: #e1eaff;
  border-radius: 9px 9px 9px 9px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #4063ff;
  img {
    width: 26px;
    height: 26px;
  }
}
.coin-select {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .type-box {
  gap: 15px;
  display: flex;
  margin-top: 10px;
  p {
    cursor: pointer;
    padding: 12px;
    border-radius: 9px 9px 9px 9px;
    border: 1px solid #d6d8db;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
  }
  .sel {
    color: #4063ff;
    border: 1px solid #4063ff;
  }
}
.img-box {
  gap: 15px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  img {
    width: 90px;
    height: 90px;
  }
  .div-box {
    flex: 1;
    padding: 12px;
    height: fit-content;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    background: rgba(214, 216, 219, 0.4);
    border-radius: 9px 9px 9px 9px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.not-support-box {
  gap: 12px;
  display: flex;
  margin-top: 15px;
  align-items: center;
  padding: 16px;
  background: #fff3e0;
  border-radius: 9px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #e6a23c;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
